// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6c7d8ac","239":"c09d3191","732":"f5aa55e4"}[chunkId] + ".chunk.js";
};